// extracted by mini-css-extract-plugin
export default {"PharmacyFormContainer":"OnkWnWKD","PharmacyFormCenterText":"uQqtg1Xa"};